export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите тип госпитализации ', trigger: 'blur' },
    ],
};
